/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_OpenInputs */

const en_us2_gallery_open = /** @type {(inputs: Gallery_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the plan`)
};

const pt_br2_gallery_open = /** @type {(inputs: Gallery_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver plano`)
};

const pt_pt2_gallery_open = /** @type {(inputs: Gallery_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver plano`)
};

/** @type {(inputs: Gallery_OpenInputs) => LocalizedString} */
const es_419_gallery_open = en_us2_gallery_open;

/** @type {(inputs: Gallery_OpenInputs) => LocalizedString} */
const fr_fr2_gallery_open = en_us2_gallery_open;

/** @type {(inputs: Gallery_OpenInputs) => LocalizedString} */
const de_de2_gallery_open = en_us2_gallery_open;

/** @type {(inputs: Gallery_OpenInputs) => LocalizedString} */
const it_it2_gallery_open = en_us2_gallery_open;

/**
* | output |
* | --- |
* | "See the plan" |
*
* @param {Gallery_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_open = /** @type {((inputs?: Gallery_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_open(inputs)
	if (locale === "es-419") return es_419_gallery_open(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_open(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_open(inputs)
	if (locale === "de-DE") return de_de2_gallery_open(inputs)
	if (locale === "it-IT") return it_it2_gallery_open(inputs)
	return en_us2_gallery_open(inputs)
});
export { gallery_open as "gallery.open" }